import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CandidateService } from '../services/candidate.service';
import { VendorService } from '../services/vendor.service';
import { UtilsDataService } from '../services/utils-data.service';

@Component({
  selector: 'app-immediate-hirings',
  templateUrl: './immediate-hirings.component.html',
  styleUrl: './immediate-hirings.component.scss'
})
export class ImmediateHiringsComponent {

  jobs: any = [];
  filterForm: FormGroup;

  // Define an array of border colors
  borderColors: string[] = [
    "#BF0000",
    "#007bff",
    "#28a745",
    "#ffc107",
    "#17a2b8",
  ];
  jobBorderColors: string[] = [];  // Array to store random border colors

  constructor(
    private router: Router,
    private candidateService: CandidateService,
    private vendorService: VendorService,
    private utilsDataService: UtilsDataService,

  ) {}

  ngOnInit() {
    this.getAllJobAdverts();
  }

  getAllJobAdverts() {
    let reqObj = {};
    this.vendorService.getAllJobAdverts(reqObj).subscribe((response) => {
      if (response.statusCode === 200) {
        this.jobs = response.data;
        console.log("jobs", this.jobs);
        // Shuffle the border colors array
        this.shuffleBorderColors();
      }
    });
  }

 /*  getAllJobs() {
    let reqObj = {};
    this.candidateService.getAllJobs(reqObj).subscribe((response) => {
      if (response.statusCode === 200) {
        this.jobs = response.data;
        console.log("jobs", this.jobs);
        // Shuffle the border colors array
        this.shuffleBorderColors();
      } else {
        console.error("Error fetching data:", response.error);
      }
    });
  } */

  // appDownload() {
  //   const dialogRef = this.dialog.open(AppDownloadPopUpComponent, {
  //     // Pass the appliedJobs data to the dialog component

  //     width: "900px",
  //   });

  //   // Subscribe to the afterClosed event to perform actions after the dialog is closed
  //   dialogRef.afterClosed().subscribe((result) => {
  //     // Handle the result if needed
  //     console.log("Dialog closed with result:", result);
  //   });
  // }

  // toggleDescription(job: any): void {
  //   job.showFullDescription = !job.showFullDescription;
  // }

  /* getLogoUrl(jobs): string {
    // Assuming you have a property named 'logo_name' in the job object
    if(jobs!=='NA'){
    return `${jobs.logo_path}/${jobs.logo_name}`;
    }
    else{
      return ''
    }
  } */

    getLogoUrl(job: any): string {
  if (!job || job === 'NA') {
    return '';
  }

  // Prioritize image sizes based on availability
  const imageName = job.image_414 || job.image_1024 || job.image_768 || job.image_1380 || job.image_1920;

  if (imageName) {
    return `${job.image_path}/${imageName}`;
  } else {
    return 'assets/images/no-logo.jpg' // Fallback if no image is available
  }
}


  getBorderColor(index: number): string {
    return this.borderColors[index % this.borderColors.length];
  }

  // Method to shuffle the border colors array
  shuffleBorderColors() {
    for (let i = this.borderColors.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.borderColors[i], this.borderColors[j]] = [
        this.borderColors[j],
        this.borderColors[i],
      ];
    }
  }

  getRandomColor2() {
    var length = 6;
    var chars = "0123456789ABCDEF";
    var hex = "#";
    while (length--) hex += chars[(Math.random() * 16) | 0];
    return hex;
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return "#" + ("000000" + color).slice(-6);
  }


  getRandomGradientColor() {
    var color1 = this.getRandomColor();
    var color2 = this.getRandomColor();
    var gradient = `linear-gradient(45deg, ${color1}, ${color2})`;
  
    return gradient;
  }


  getRandomBorderColor(): string {
    const randomColor = this.getRandomColor1();
    return `2px solid ${randomColor}`; // 2px is the border width
  }

  getRandomColor1(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  goToDetails(obj:any){
    // this.utilsDataService.advertDetails=obj;
    this.router.navigate(['advertise-view',obj.slug])
    //this.router.navigate(['vendor/advertise-detail-page',obj.slug])
    console.log("advertise details",obj)
  }

  offers = [
    {
      icon: 'assets/first.png',
      category: 'BUS',
      title: 'Save up to Rs 250 on bus tickets',
      validity: '28 Feb',
      code: 'FIRST',
      bgColor: '#0f6fc6'
    },
    {
      icon: 'assets/icici.png',
      category: 'BUS',
      title: 'Save up to Rs 500 with ICICI Debit',
      validity: '18 Feb',
      code: 'ICICI500',
      bgColor: '#1b8769'
    },
    {
      icon: 'assets/superhit.png',
      category: 'BUS',
      title: 'Save up to Rs 300 on AP, TS routes',
      validity: '28 Feb',
      code: 'SUPERHIT',
      bgColor: '#9a1b1b'
    }
  ];
}